import React from 'react';
import { TableRow, TableCell, TableHead, TableSortLabel, Tooltip } from '@material-ui/core';

class EnhancedTableHead extends React.Component {
    createSortHandler = (property) => (event) => {
        const { onRequestSort } = this.props;
        onRequestSort(event, property);
    };

    render() {
        const { order, orderBy, columns } = this.props;

        if (!columns) {
            return null;
        }

        return (
            <TableHead>
                <TableRow>
                    {columns.map(
                        (column, index) => (
                            <TableCell
                                key={column.fieldName || index}
                                align={column.align || 'left'}
                                padding={column.disablePadding ? 'none' : 'default'}
                                sortDirection={orderBy === column.fieldName ? order : false}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.fieldName}
                                        direction={order}
                                        onClick={this.createSortHandler(column.fieldName)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        ),
                        this
                    )}
                </TableRow>
            </TableHead>
        );
    }
}

export default EnhancedTableHead;
